import Glide from '@glidejs/glide'

new Glide('.glide', {
    type: 'carousel',
    slidesToShow: 1,
    dots: '#dots',
    draggable: true
}).mount()
